import { useSyncExternalStore } from 'react';
import { liveInventoryDisplayStore } from '../store/liveInventoryDisplayStore';
import type { AmhsLiveInventory } from '../types/amhsStream';

const subscribe = (onStoreChange: () => void) =>
  liveInventoryDisplayStore.subscribe(onStoreChange);
const getSnapshot = () => liveInventoryDisplayStore.getSnapshot();

/**
 * Live inventory as it should be rendered — stockers and gates hold their counts
 * until the matching OHT pickup/drop animation completes.
 */
export function useLiveInventoryDisplay(): AmhsLiveInventory | null {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

export function useLiveInventoryGates(): AmhsLiveInventory['gates'] {
  return useLiveInventoryDisplay()?.gates;
}
